import { Button, Icon, Spinner } from "../../components";
import Dashboard from "../../layout/Dashboard";
import { currencyFormat } from "../../utils/Formats";

// this is currently made to be returned on payment pages depeneding on the state of transaction
// index.js has the example
const PaymentProcessing = ({ state, data = {}, onReturn }) => {
  const name = data.name;
  const isDowngrade = data.direction === "Downgrade";
  const hasNoCharge = !isDowngrade && Number(data.total) === 0;
  
  if (state === false || state === "failure")
    return (
      <Dashboard.Content style={{ maxWidth: "688px" }}>
        <div className="processing">
          <Icon id="icon-close" size={72} className="icon-denied" />
          <h1 className="processing-title">Pagamento não autorizado</h1>
          <p className="processing-description">
            Sua operadora do cartão não autorizou essa
            <br className="d-md-none" /> transação
            <br className="d-none d-md-block" /> no valor de{" "}
            <span className="fw-500">{currencyFormat(data.total)}.</span>
          </p>
          <Button onClick={onReturn} variant="primary" className="processing-button">
            Revisar dados informados
          </Button>
        </div>
      </Dashboard.Content>
    );

  if (state === true || state === "success")
    return (
      <Dashboard.Content style={{ maxWidth: "688px" }}>
        <div className="processing">
          <Icon id="icon-check" size={72} className="icon-success" />
          <h1 className="processing-title">
            {isDowngrade ? "Alteração agendada!" : hasNoCharge ? "Plano alterado!" : "Pagamento aprovado!"}
          </h1>
          <p className="processing-description">
            {name}, estamos redirecionando você para o painel, por favor
            aguarde.
          </p>
          {data.PaymentInfo}
          <Button onClick={onReturn} variant="primary" className="processing-button">
            Ir para a assinafy
          </Button>
        </div>
      </Dashboard.Content>
    );
  return (
    <Dashboard.Content style={{ maxWidth: "688px" }}>
      <div className="processing">
        <Spinner size={72} />
        <h1 className="processing-title">
          {isDowngrade ? "Agendando alteração..." : hasNoCharge ? "Alterando seu plano..." : "Processando pagamento..."}
        </h1>
        <p className="processing-description">
          {name}, {isDowngrade || hasNoCharge ? "estamos confirmando a alteração do seu plano" : "estamos realizando a cobrança"}, por favor aguarde.
        </p>
      </div>
    </Dashboard.Content>
  );
};

export default PaymentProcessing;
